import { FetchBusinessRolesWithPermissionsResponse } from "./types";
import axios from "@/api/axiosInstance";

interface ApiResponse {
  data: FetchBusinessRolesWithPermissionsResponse;
}

export const fetchBusinessRolesWithPermissions =
  async (): Promise<FetchBusinessRolesWithPermissionsResponse> => {
    const response = await axios.get<ApiResponse>(
      "/api/private/business-roles/permissions",
    );
    return response.data.data;
  };
